(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire90c1"];
var parcelRegister = parcelRequire.register;
parcelRegister("dTXJT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9qJx9")).popup_default; });

var $9qJx9 = parcelRequire("9qJx9");
parcelRequire("jQaZW");
parcelRequire("anNne");
parcelRequire("5anEP");
parcelRequire("hE82n");
parcelRequire("g8OZA");

});
parcelRegister("9qJx9", function(module, exports) {

$parcel$export(module.exports, "popup_default", function () { return $6dd9dccc18a67ffd$export$dccdde829286d84f; });

var $jQaZW = parcelRequire("jQaZW");
// src/components/popup/popup.ts
var $6dd9dccc18a67ffd$export$dccdde829286d84f = (0, $jQaZW.SlPopup);
(0, $jQaZW.SlPopup).define("sl-popup");

});
parcelRegister("jQaZW", function(module, exports) {

$parcel$export(module.exports, "SlPopup", function () { return $e71b679c03e9d88f$export$6fe469f0a31d1d6e; });

var $anNne = parcelRequire("anNne");

var $5anEP = parcelRequire("5anEP");

var $hE82n = parcelRequire("hE82n");

var $g8OZA = parcelRequire("g8OZA");

var $85Vfw = parcelRequire("85Vfw");
parcelRequire("8ScLW");
var $iokeX = parcelRequire("iokeX");
parcelRequire("3v1FY");
var $6NpbG = parcelRequire("6NpbG");

var $ljC8S = parcelRequire("ljC8S");
parcelRequire("a8L7v");
var $cB76X = parcelRequire("cB76X");
var $cqRtT = parcelRequire("cqRtT");
function $e71b679c03e9d88f$var$isVirtualElement(e) {
    return e !== null && typeof e === "object" && "getBoundingClientRect" in e && ("contextElement" in e ? e instanceof Element : true);
}
var $e71b679c03e9d88f$export$6fe469f0a31d1d6e = class extends (0, $hE82n.ShoelaceElement) {
    constructor(){
        super(...arguments);
        this.active = false;
        this.placement = "top";
        this.strategy = "absolute";
        this.distance = 0;
        this.skidding = 0;
        this.arrow = false;
        this.arrowPlacement = "anchor";
        this.arrowPadding = 10;
        this.flip = false;
        this.flipFallbackPlacements = "";
        this.flipFallbackStrategy = "best-fit";
        this.flipPadding = 0;
        this.shift = false;
        this.shiftPadding = 0;
        this.autoSizePadding = 0;
        this.hoverBridge = false;
        this.updateHoverBridge = ()=>{
            if (this.hoverBridge && this.anchorEl) {
                const anchorRect = this.anchorEl.getBoundingClientRect();
                const popupRect = this.popup.getBoundingClientRect();
                const isVertical = this.placement.includes("top") || this.placement.includes("bottom");
                let topLeftX = 0;
                let topLeftY = 0;
                let topRightX = 0;
                let topRightY = 0;
                let bottomLeftX = 0;
                let bottomLeftY = 0;
                let bottomRightX = 0;
                let bottomRightY = 0;
                if (isVertical) {
                    if (anchorRect.top < popupRect.top) {
                        topLeftX = anchorRect.left;
                        topLeftY = anchorRect.bottom;
                        topRightX = anchorRect.right;
                        topRightY = anchorRect.bottom;
                        bottomLeftX = popupRect.left;
                        bottomLeftY = popupRect.top;
                        bottomRightX = popupRect.right;
                        bottomRightY = popupRect.top;
                    } else {
                        topLeftX = popupRect.left;
                        topLeftY = popupRect.bottom;
                        topRightX = popupRect.right;
                        topRightY = popupRect.bottom;
                        bottomLeftX = anchorRect.left;
                        bottomLeftY = anchorRect.top;
                        bottomRightX = anchorRect.right;
                        bottomRightY = anchorRect.top;
                    }
                } else if (anchorRect.left < popupRect.left) {
                    topLeftX = anchorRect.right;
                    topLeftY = anchorRect.top;
                    topRightX = popupRect.left;
                    topRightY = popupRect.top;
                    bottomLeftX = anchorRect.right;
                    bottomLeftY = anchorRect.bottom;
                    bottomRightX = popupRect.left;
                    bottomRightY = popupRect.bottom;
                } else {
                    topLeftX = popupRect.right;
                    topLeftY = popupRect.top;
                    topRightX = anchorRect.left;
                    topRightY = anchorRect.top;
                    bottomLeftX = popupRect.right;
                    bottomLeftY = popupRect.bottom;
                    bottomRightX = anchorRect.left;
                    bottomRightY = anchorRect.bottom;
                }
                this.style.setProperty("--hover-bridge-top-left-x", `${topLeftX}px`);
                this.style.setProperty("--hover-bridge-top-left-y", `${topLeftY}px`);
                this.style.setProperty("--hover-bridge-top-right-x", `${topRightX}px`);
                this.style.setProperty("--hover-bridge-top-right-y", `${topRightY}px`);
                this.style.setProperty("--hover-bridge-bottom-left-x", `${bottomLeftX}px`);
                this.style.setProperty("--hover-bridge-bottom-left-y", `${bottomLeftY}px`);
                this.style.setProperty("--hover-bridge-bottom-right-x", `${bottomRightX}px`);
                this.style.setProperty("--hover-bridge-bottom-right-y", `${bottomRightY}px`);
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.updateComplete;
        this.start();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stop();
    }
    async updated(changedProps) {
        super.updated(changedProps);
        if (changedProps.has("active")) {
            if (this.active) this.start();
            else this.stop();
        }
        if (changedProps.has("anchor")) this.handleAnchorChange();
        if (this.active) {
            await this.updateComplete;
            this.reposition();
        }
    }
    async handleAnchorChange() {
        await this.stop();
        if (this.anchor && typeof this.anchor === "string") {
            const root = this.getRootNode();
            this.anchorEl = root.getElementById(this.anchor);
        } else if (this.anchor instanceof Element || $e71b679c03e9d88f$var$isVirtualElement(this.anchor)) this.anchorEl = this.anchor;
        else this.anchorEl = this.querySelector('[slot="anchor"]');
        if (this.anchorEl instanceof HTMLSlotElement) this.anchorEl = this.anchorEl.assignedElements({
            flatten: true
        })[0];
        if (this.anchorEl && this.active) this.start();
    }
    start() {
        if (!this.anchorEl) return;
        this.cleanup = (0, $85Vfw.autoUpdate)(this.anchorEl, this.popup, ()=>{
            this.reposition();
        });
    }
    async stop() {
        return new Promise((resolve)=>{
            if (this.cleanup) {
                this.cleanup();
                this.cleanup = void 0;
                this.removeAttribute("data-current-placement");
                this.style.removeProperty("--auto-size-available-width");
                this.style.removeProperty("--auto-size-available-height");
                requestAnimationFrame(()=>resolve());
            } else resolve();
        });
    }
    /** Forces the popup to recalculate and reposition itself. */ reposition() {
        if (!this.active || !this.anchorEl) return;
        const middleware = [
            // The offset middleware goes first
            (0, $85Vfw.offset)({
                mainAxis: this.distance,
                crossAxis: this.skidding
            })
        ];
        if (this.sync) middleware.push((0, $85Vfw.size)({
            apply: ({ rects: rects })=>{
                const syncWidth = this.sync === "width" || this.sync === "both";
                const syncHeight = this.sync === "height" || this.sync === "both";
                this.popup.style.width = syncWidth ? `${rects.reference.width}px` : "";
                this.popup.style.height = syncHeight ? `${rects.reference.height}px` : "";
            }
        }));
        else {
            this.popup.style.width = "";
            this.popup.style.height = "";
        }
        if (this.flip) middleware.push((0, $85Vfw.flip)({
            boundary: this.flipBoundary,
            // @ts-expect-error - We're converting a string attribute to an array here
            fallbackPlacements: this.flipFallbackPlacements,
            fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
            padding: this.flipPadding
        }));
        if (this.shift) middleware.push((0, $85Vfw.shift)({
            boundary: this.shiftBoundary,
            padding: this.shiftPadding
        }));
        if (this.autoSize) middleware.push((0, $85Vfw.size)({
            boundary: this.autoSizeBoundary,
            padding: this.autoSizePadding,
            apply: ({ availableWidth: availableWidth, availableHeight: availableHeight })=>{
                if (this.autoSize === "vertical" || this.autoSize === "both") this.style.setProperty("--auto-size-available-height", `${availableHeight}px`);
                else this.style.removeProperty("--auto-size-available-height");
                if (this.autoSize === "horizontal" || this.autoSize === "both") this.style.setProperty("--auto-size-available-width", `${availableWidth}px`);
                else this.style.removeProperty("--auto-size-available-width");
            }
        }));
        else {
            this.style.removeProperty("--auto-size-available-width");
            this.style.removeProperty("--auto-size-available-height");
        }
        if (this.arrow) middleware.push((0, $85Vfw.arrow)({
            element: this.arrowEl,
            padding: this.arrowPadding
        }));
        const getOffsetParent = this.strategy === "absolute" ? (element)=>(0, $85Vfw.platform).getOffsetParent(element, (0, $ljC8S.offsetParent)) : (0, $85Vfw.platform).getOffsetParent;
        (0, $85Vfw.computePosition)(this.anchorEl, this.popup, {
            placement: this.placement,
            middleware: middleware,
            strategy: this.strategy,
            platform: (0, $g8OZA.__spreadProps)((0, $g8OZA.__spreadValues)({}, (0, $85Vfw.platform)), {
                getOffsetParent: getOffsetParent
            })
        }).then(({ x: x, y: y, middlewareData: middlewareData, placement: placement })=>{
            const isRtl = this.matches(":dir(rtl)");
            const staticSide = {
                top: "bottom",
                right: "left",
                bottom: "top",
                left: "right"
            }[placement.split("-")[0]];
            this.setAttribute("data-current-placement", placement);
            Object.assign(this.popup.style, {
                left: `${x}px`,
                top: `${y}px`
            });
            if (this.arrow) {
                const arrowX = middlewareData.arrow.x;
                const arrowY = middlewareData.arrow.y;
                let top = "";
                let right = "";
                let bottom = "";
                let left = "";
                if (this.arrowPlacement === "start") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    top = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? value : "";
                    left = isRtl ? "" : value;
                } else if (this.arrowPlacement === "end") {
                    const value = typeof arrowX === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                    right = isRtl ? "" : value;
                    left = isRtl ? value : "";
                    bottom = typeof arrowY === "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
                } else if (this.arrowPlacement === "center") {
                    left = typeof arrowX === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                    top = typeof arrowY === "number" ? `calc(50% - var(--arrow-size-diagonal))` : "";
                } else {
                    left = typeof arrowX === "number" ? `${arrowX}px` : "";
                    top = typeof arrowY === "number" ? `${arrowY}px` : "";
                }
                Object.assign(this.arrowEl.style, {
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    [staticSide]: "calc(var(--arrow-size-diagonal) * -1)"
                });
            }
        });
        requestAnimationFrame(()=>this.updateHoverBridge());
        this.emit("sl-reposition");
    }
    render() {
        return (0, $6NpbG.html)`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${(0, $iokeX.classMap)({
            "popup-hover-bridge": true,
            "popup-hover-bridge--visible": this.hoverBridge && this.active
        })}
      ></span>

      <div
        part="popup"
        class=${(0, $iokeX.classMap)({
            popup: true,
            "popup--active": this.active,
            "popup--fixed": this.strategy === "fixed",
            "popup--has-arrow": this.arrow
        })}
      >
        <slot></slot>
        ${this.arrow ? (0, $6NpbG.html)`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
    }
};
$e71b679c03e9d88f$export$6fe469f0a31d1d6e.styles = [
    (0, $5anEP.component_styles_default),
    (0, $anNne.popup_styles_default)
];
(0, $g8OZA.__decorateClass)([
    (0, $cqRtT.query)(".popup")
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "popup", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cqRtT.query)(".popup__arrow")
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "arrowEl", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)()
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "anchor", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Boolean,
        reflect: true
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "active", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        reflect: true
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "placement", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        reflect: true
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "strategy", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Number
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "distance", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Number
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "skidding", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Boolean
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "arrow", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "arrow-placement"
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "arrowPlacement", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "arrow-padding",
        type: Number
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "arrowPadding", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Boolean
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "flip", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "flip-fallback-placements",
        converter: {
            fromAttribute: (value)=>{
                return value.split(" ").map((p)=>p.trim()).filter((p)=>p !== "");
            },
            toAttribute: (value)=>{
                return value.join(" ");
            }
        }
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "flipFallbackPlacements", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "flip-fallback-strategy"
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "flipFallbackStrategy", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Object
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "flipBoundary", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "flip-padding",
        type: Number
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "flipPadding", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Boolean
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "shift", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Object
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "shiftBoundary", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "shift-padding",
        type: Number
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "shiftPadding", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "auto-size"
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "autoSize", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)()
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "sync", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        type: Object
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "autoSizeBoundary", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "auto-size-padding",
        type: Number
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "autoSizePadding", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)({
        attribute: "hover-bridge",
        type: Boolean
    })
], $e71b679c03e9d88f$export$6fe469f0a31d1d6e.prototype, "hoverBridge", 2);

});
parcelRegister("anNne", function(module, exports) {

$parcel$export(module.exports, "popup_styles_default", function () { return $78f259f4a3ae1787$export$51897b955cb6c203; });
// src/components/popup/popup.styles.ts
parcelRequire("3v1FY");
var $eEUfi = parcelRequire("eEUfi");
var $78f259f4a3ae1787$export$51897b955cb6c203 = (0, $eEUfi.css)`
  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge--visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }
`;

});
parcelRegister("3v1FY", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("eEUfi")).css; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("6NpbG")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("hnplv")).LitElement; });
parcelRequire("6CB51");
parcelRequire("6NpbG");
parcelRequire("hnplv");
parcelRequire("7NKQj");

});
parcelRegister("6CB51", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $4d230e06f2d42056$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $4d230e06f2d42056$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $4d230e06f2d42056$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("eEUfi")).css; });

var $eEUfi = parcelRequire("eEUfi");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $4d230e06f2d42056$var$i, defineProperty: $4d230e06f2d42056$var$e, getOwnPropertyDescriptor: $4d230e06f2d42056$var$r, getOwnPropertyNames: $4d230e06f2d42056$var$h, getOwnPropertySymbols: $4d230e06f2d42056$var$o, getPrototypeOf: $4d230e06f2d42056$var$n } = Object, $4d230e06f2d42056$var$a = globalThis, $4d230e06f2d42056$var$c = $4d230e06f2d42056$var$a.trustedTypes, $4d230e06f2d42056$var$l = $4d230e06f2d42056$var$c ? $4d230e06f2d42056$var$c.emptyScript : "", $4d230e06f2d42056$var$p = $4d230e06f2d42056$var$a.reactiveElementPolyfillSupport, $4d230e06f2d42056$var$d = (t, s)=>t, $4d230e06f2d42056$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $4d230e06f2d42056$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $4d230e06f2d42056$export$53a6892c50694894 = (t, s)=>!$4d230e06f2d42056$var$i(t, s), $4d230e06f2d42056$var$y = {
    attribute: !0,
    type: String,
    converter: $4d230e06f2d42056$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $4d230e06f2d42056$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $4d230e06f2d42056$var$a.litPropertyMetadata ??= new WeakMap;
class $4d230e06f2d42056$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $4d230e06f2d42056$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $4d230e06f2d42056$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $4d230e06f2d42056$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $4d230e06f2d42056$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($4d230e06f2d42056$var$d("elementProperties"))) return;
        const t = $4d230e06f2d42056$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($4d230e06f2d42056$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($4d230e06f2d42056$var$d("properties"))) {
            const t = this.properties, s = [
                ...$4d230e06f2d42056$var$h(t),
                ...$4d230e06f2d42056$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $eEUfi.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $eEUfi.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $eEUfi.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $4d230e06f2d42056$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $4d230e06f2d42056$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $4d230e06f2d42056$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$4d230e06f2d42056$export$c7c07a37856565d.elementStyles = [], $4d230e06f2d42056$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $4d230e06f2d42056$export$c7c07a37856565d[$4d230e06f2d42056$var$d("elementProperties")] = new Map, $4d230e06f2d42056$export$c7c07a37856565d[$4d230e06f2d42056$var$d("finalized")] = new Map, $4d230e06f2d42056$var$p?.({
    ReactiveElement: $4d230e06f2d42056$export$c7c07a37856565d
}), ($4d230e06f2d42056$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("eEUfi", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $aac06e58877f4a4b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $aac06e58877f4a4b$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $aac06e58877f4a4b$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aac06e58877f4a4b$var$t = globalThis, $aac06e58877f4a4b$export$b4d10f6001c083c2 = $aac06e58877f4a4b$var$t.ShadowRoot && (void 0 === $aac06e58877f4a4b$var$t.ShadyCSS || $aac06e58877f4a4b$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $aac06e58877f4a4b$var$s = Symbol(), $aac06e58877f4a4b$var$o = new WeakMap;
class $aac06e58877f4a4b$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $aac06e58877f4a4b$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($aac06e58877f4a4b$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $aac06e58877f4a4b$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $aac06e58877f4a4b$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $aac06e58877f4a4b$export$8d80f9cac07cdb3 = (t)=>new $aac06e58877f4a4b$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $aac06e58877f4a4b$var$s), $aac06e58877f4a4b$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $aac06e58877f4a4b$export$505d1e8739bad805(o, t, $aac06e58877f4a4b$var$s);
}, $aac06e58877f4a4b$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($aac06e58877f4a4b$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $aac06e58877f4a4b$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $aac06e58877f4a4b$export$ee69dfd951e24778 = $aac06e58877f4a4b$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $aac06e58877f4a4b$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("6NpbG", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $4f2adb61de799911$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "noChange", function () { return $4f2adb61de799911$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "render", function () { return $4f2adb61de799911$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4f2adb61de799911$var$n = globalThis, $4f2adb61de799911$var$c = $4f2adb61de799911$var$n.trustedTypes, $4f2adb61de799911$var$h = $4f2adb61de799911$var$c ? $4f2adb61de799911$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $4f2adb61de799911$var$f = "$lit$", $4f2adb61de799911$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $4f2adb61de799911$var$m = "?" + $4f2adb61de799911$var$v, $4f2adb61de799911$var$_ = `<${$4f2adb61de799911$var$m}>`, $4f2adb61de799911$var$w = document, $4f2adb61de799911$var$lt = ()=>$4f2adb61de799911$var$w.createComment(""), $4f2adb61de799911$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $4f2adb61de799911$var$g = Array.isArray, $4f2adb61de799911$var$$ = (t)=>$4f2adb61de799911$var$g(t) || "function" == typeof t?.[Symbol.iterator], $4f2adb61de799911$var$x = "[ 	\n\f\r]", $4f2adb61de799911$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $4f2adb61de799911$var$E = /-->/g, $4f2adb61de799911$var$k = />/g, $4f2adb61de799911$var$O = RegExp(`>|${$4f2adb61de799911$var$x}(?:([^\\s"'>=/]+)(${$4f2adb61de799911$var$x}*=${$4f2adb61de799911$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $4f2adb61de799911$var$S = /'/g, $4f2adb61de799911$var$j = /"/g, $4f2adb61de799911$var$M = /^(?:script|style|textarea|title)$/i, $4f2adb61de799911$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $4f2adb61de799911$export$c0bb0b647f701bb5 = $4f2adb61de799911$var$P(1), $4f2adb61de799911$export$7ed1367e7fa1ad68 = $4f2adb61de799911$var$P(2), $4f2adb61de799911$export$47d5b44d225be5b4 = $4f2adb61de799911$var$P(3), $4f2adb61de799911$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $4f2adb61de799911$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $4f2adb61de799911$var$V = new WeakMap, $4f2adb61de799911$var$I = $4f2adb61de799911$var$w.createTreeWalker($4f2adb61de799911$var$w, 129);
function $4f2adb61de799911$var$N(t, i) {
    if (!$4f2adb61de799911$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $4f2adb61de799911$var$h ? $4f2adb61de799911$var$h.createHTML(i) : i;
}
const $4f2adb61de799911$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $4f2adb61de799911$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $4f2adb61de799911$var$T ? "!--" === l[1] ? n = $4f2adb61de799911$var$E : void 0 !== l[1] ? n = $4f2adb61de799911$var$k : void 0 !== l[2] ? ($4f2adb61de799911$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $4f2adb61de799911$var$O) : void 0 !== l[3] && (n = $4f2adb61de799911$var$O) : n === $4f2adb61de799911$var$O ? ">" === l[0] ? (n = h ?? $4f2adb61de799911$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $4f2adb61de799911$var$O : '"' === l[3] ? $4f2adb61de799911$var$j : $4f2adb61de799911$var$S) : n === $4f2adb61de799911$var$j || n === $4f2adb61de799911$var$S ? n = $4f2adb61de799911$var$O : n === $4f2adb61de799911$var$E || n === $4f2adb61de799911$var$k ? n = $4f2adb61de799911$var$T : (n = $4f2adb61de799911$var$O, h = void 0);
        const u = n === $4f2adb61de799911$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $4f2adb61de799911$var$T ? s + $4f2adb61de799911$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $4f2adb61de799911$var$f + s.slice(c) + $4f2adb61de799911$var$v + u) : s + $4f2adb61de799911$var$v + (-2 === c ? i : u);
    }
    return [
        $4f2adb61de799911$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $4f2adb61de799911$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $4f2adb61de799911$var$U(t, i);
        if (this.el = $4f2adb61de799911$var$B.createElement(l, s), $4f2adb61de799911$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $4f2adb61de799911$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($4f2adb61de799911$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($4f2adb61de799911$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $4f2adb61de799911$var$Y : "?" === n[1] ? $4f2adb61de799911$var$Z : "@" === n[1] ? $4f2adb61de799911$var$q : $4f2adb61de799911$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($4f2adb61de799911$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($4f2adb61de799911$var$M.test(e.tagName)) {
                    const t = e.textContent.split($4f2adb61de799911$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $4f2adb61de799911$var$c ? $4f2adb61de799911$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $4f2adb61de799911$var$lt()), $4f2adb61de799911$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $4f2adb61de799911$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $4f2adb61de799911$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($4f2adb61de799911$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $4f2adb61de799911$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $4f2adb61de799911$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $4f2adb61de799911$var$z(t, i, s = t, e) {
    if (i === $4f2adb61de799911$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $4f2adb61de799911$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $4f2adb61de799911$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $4f2adb61de799911$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $4f2adb61de799911$var$w).importNode(i, !0);
        $4f2adb61de799911$var$I.currentNode = e;
        let h = $4f2adb61de799911$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $4f2adb61de799911$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $4f2adb61de799911$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $4f2adb61de799911$var$I.nextNode(), o++);
        }
        return $4f2adb61de799911$var$I.currentNode = $4f2adb61de799911$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $4f2adb61de799911$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $4f2adb61de799911$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $4f2adb61de799911$var$z(this, t, i), $4f2adb61de799911$var$st(t) ? t === $4f2adb61de799911$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $4f2adb61de799911$export$45b790e32b2810ee && this._$AR(), this._$AH = $4f2adb61de799911$export$45b790e32b2810ee) : t !== this._$AH && t !== $4f2adb61de799911$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $4f2adb61de799911$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $4f2adb61de799911$export$45b790e32b2810ee && $4f2adb61de799911$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($4f2adb61de799911$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $4f2adb61de799911$var$B.createElement($4f2adb61de799911$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $4f2adb61de799911$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $4f2adb61de799911$var$V.get(t.strings);
        return void 0 === i && $4f2adb61de799911$var$V.set(t.strings, i = new $4f2adb61de799911$var$B(t)), i;
    }
    k(t) {
        $4f2adb61de799911$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $4f2adb61de799911$var$et(this.O($4f2adb61de799911$var$lt()), this.O($4f2adb61de799911$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $4f2adb61de799911$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $4f2adb61de799911$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $4f2adb61de799911$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $4f2adb61de799911$var$z(this, t, i, 0), o = !$4f2adb61de799911$var$st(t) || t !== this._$AH && t !== $4f2adb61de799911$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $4f2adb61de799911$var$z(this, e[s + n], i, n), r === $4f2adb61de799911$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$4f2adb61de799911$var$st(r) || r !== this._$AH[n], r === $4f2adb61de799911$export$45b790e32b2810ee ? t = $4f2adb61de799911$export$45b790e32b2810ee : t !== $4f2adb61de799911$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $4f2adb61de799911$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $4f2adb61de799911$var$Y extends $4f2adb61de799911$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $4f2adb61de799911$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $4f2adb61de799911$var$Z extends $4f2adb61de799911$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $4f2adb61de799911$export$45b790e32b2810ee);
    }
}
class $4f2adb61de799911$var$q extends $4f2adb61de799911$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $4f2adb61de799911$var$z(this, t, i, 0) ?? $4f2adb61de799911$export$45b790e32b2810ee) === $4f2adb61de799911$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $4f2adb61de799911$export$45b790e32b2810ee && s !== $4f2adb61de799911$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $4f2adb61de799911$export$45b790e32b2810ee && (s === $4f2adb61de799911$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $4f2adb61de799911$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $4f2adb61de799911$var$z(this, t);
    }
}
const $4f2adb61de799911$export$8613d1ca9052b22e = {
    M: $4f2adb61de799911$var$f,
    P: $4f2adb61de799911$var$v,
    A: $4f2adb61de799911$var$m,
    C: 1,
    L: $4f2adb61de799911$var$U,
    R: $4f2adb61de799911$var$F,
    D: $4f2adb61de799911$var$$,
    V: $4f2adb61de799911$var$z,
    I: $4f2adb61de799911$var$et,
    H: $4f2adb61de799911$var$G,
    N: $4f2adb61de799911$var$Z,
    U: $4f2adb61de799911$var$q,
    B: $4f2adb61de799911$var$Y,
    F: $4f2adb61de799911$var$K
}, $4f2adb61de799911$var$Re = $4f2adb61de799911$var$n.litHtmlPolyfillSupport;
$4f2adb61de799911$var$Re?.($4f2adb61de799911$var$B, $4f2adb61de799911$var$et), ($4f2adb61de799911$var$n.litHtmlVersions ??= []).push("3.2.0");
const $4f2adb61de799911$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $4f2adb61de799911$var$et(i.insertBefore($4f2adb61de799911$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("hnplv", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("eEUfi")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("6CB51")).ReactiveElement; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("6NpbG")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("6NpbG")).noChange; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("6NpbG")).render; });

$parcel$export(module.exports, "LitElement", function () { return $ca683ed1a05f1639$export$3f2f9f5909897157; });

var $6CB51 = parcelRequire("6CB51");

var $6NpbG = parcelRequire("6NpbG");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $ca683ed1a05f1639$export$3f2f9f5909897157 extends (0, $6CB51.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $6NpbG.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $6NpbG.noChange;
    }
}
$ca683ed1a05f1639$export$3f2f9f5909897157._$litElement$ = !0, $ca683ed1a05f1639$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $ca683ed1a05f1639$export$3f2f9f5909897157
});
const $ca683ed1a05f1639$var$f = globalThis.litElementPolyfillSupport;
$ca683ed1a05f1639$var$f?.({
    LitElement: $ca683ed1a05f1639$export$3f2f9f5909897157
});
const $ca683ed1a05f1639$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("7NKQj", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5ae172006b44f3b5$export$6acf61af03e62db = !1;

});



parcelRegister("5anEP", function(module, exports) {

$parcel$export(module.exports, "component_styles_default", function () { return $3c303cd1ebbbca4e$export$e1ac0a3ec62d1269; });
// src/styles/component.styles.ts
parcelRequire("3v1FY");
var $eEUfi = parcelRequire("eEUfi");
var $3c303cd1ebbbca4e$export$e1ac0a3ec62d1269 = (0, $eEUfi.css)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;

});

parcelRegister("hE82n", function(module, exports) {

$parcel$export(module.exports, "ShoelaceElement", function () { return $cd8c68221eb20087$export$6f25236e887097b; });

var $g8OZA = parcelRequire("g8OZA");
parcelRequire("3v1FY");
var $hnplv = parcelRequire("hnplv");
parcelRequire("a8L7v");
var $cB76X = parcelRequire("cB76X");
var $cd8c68221eb20087$var$_hasRecordedInitialProperties;
var $cd8c68221eb20087$export$6f25236e887097b = class extends (0, $hnplv.LitElement) {
    constructor(){
        super();
        (0, $g8OZA.__privateAdd)(this, $cd8c68221eb20087$var$_hasRecordedInitialProperties, false);
        // Store the constructor value of all `static properties = {}`
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $g8OZA.__spreadValues)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options);
            } catch (_err) {
                customElements.define(name, class extends elementConstructor {
                }, options);
            }
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $g8OZA.__privateGet)(this, $cd8c68221eb20087$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $g8OZA.__privateSet)(this, $cd8c68221eb20087$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
};
$cd8c68221eb20087$var$_hasRecordedInitialProperties = new WeakMap();
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$cd8c68221eb20087$export$6f25236e887097b.version = "2.17.1";
$cd8c68221eb20087$export$6f25236e887097b.dependencies = {};
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)()
], $cd8c68221eb20087$export$6f25236e887097b.prototype, "dir", 2);
(0, $g8OZA.__decorateClass)([
    (0, $cB76X.property)()
], $cd8c68221eb20087$export$6f25236e887097b.prototype, "lang", 2);

});
parcelRegister("g8OZA", function(module, exports) {

$parcel$export(module.exports, "__spreadValues", function () { return $bc04f2b1ee28a385$export$7de063a7aa429f6c; });
$parcel$export(module.exports, "__spreadProps", function () { return $bc04f2b1ee28a385$export$f4da8f157c1253f7; });
$parcel$export(module.exports, "__decorateClass", function () { return $bc04f2b1ee28a385$export$85c93885f16e8446; });
$parcel$export(module.exports, "__privateGet", function () { return $bc04f2b1ee28a385$export$18a094aefa070634; });
$parcel$export(module.exports, "__privateAdd", function () { return $bc04f2b1ee28a385$export$addf369becd23283; });
$parcel$export(module.exports, "__privateSet", function () { return $bc04f2b1ee28a385$export$42432efe6614d3b4; });
var $bc04f2b1ee28a385$var$__defProp = Object.defineProperty;
var $bc04f2b1ee28a385$var$__defProps = Object.defineProperties;
var $bc04f2b1ee28a385$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $bc04f2b1ee28a385$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $bc04f2b1ee28a385$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bc04f2b1ee28a385$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bc04f2b1ee28a385$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bc04f2b1ee28a385$var$__knownSymbol = (name, symbol)=>{
    return (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
};
var $bc04f2b1ee28a385$var$__defNormalProp = (obj, key, value)=>key in obj ? $bc04f2b1ee28a385$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bc04f2b1ee28a385$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($bc04f2b1ee28a385$var$__hasOwnProp.call(b, prop)) $bc04f2b1ee28a385$var$__defNormalProp(a, prop, b[prop]);
    if ($bc04f2b1ee28a385$var$__getOwnPropSymbols) {
        for (var prop of $bc04f2b1ee28a385$var$__getOwnPropSymbols(b))if ($bc04f2b1ee28a385$var$__propIsEnum.call(b, prop)) $bc04f2b1ee28a385$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $bc04f2b1ee28a385$export$f4da8f157c1253f7 = (a, b)=>$bc04f2b1ee28a385$var$__defProps(a, $bc04f2b1ee28a385$var$__getOwnPropDescs(b));
var $bc04f2b1ee28a385$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $bc04f2b1ee28a385$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $bc04f2b1ee28a385$var$__defProp(target, key, result);
    return result;
};
var $bc04f2b1ee28a385$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $bc04f2b1ee28a385$export$18a094aefa070634 = (obj, member, getter)=>{
    $bc04f2b1ee28a385$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $bc04f2b1ee28a385$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $bc04f2b1ee28a385$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $bc04f2b1ee28a385$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $bc04f2b1ee28a385$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $bc04f2b1ee28a385$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$bc04f2b1ee28a385$var$__knownSymbol("asyncIterator")];
    var isAwait = false;
    var method;
    var it = {};
    if (obj == null) {
        obj = value[$bc04f2b1ee28a385$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $bc04f2b1ee28a385$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) throw TypeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$bc04f2b1ee28a385$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};

});

parcelRegister("a8L7v", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("cB76X")).property; });
$parcel$export(module.exports, "query", function () { return (parcelRequire("cqRtT")).query; });
parcelRequire("j6CE7");
parcelRequire("cB76X");
parcelRequire("jUWNV");
parcelRequire("1McSN");
parcelRequire("cqRtT");
parcelRequire("ftUAQ");
parcelRequire("4tsVC");
parcelRequire("jSRj3");
parcelRequire("9unhH");

});
parcelRegister("j6CE7", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $de8c8e2c6b53c7ee$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("cB76X", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $92be74e28186bf19$export$d541bacb2bda4494; });

var $6CB51 = parcelRequire("6CB51");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $92be74e28186bf19$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $6CB51.defaultConverter),
    reflect: !1,
    hasChanged: (0, $6CB51.notEqual)
}, $92be74e28186bf19$export$8d623b1670eb40f4 = (t = $92be74e28186bf19$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $92be74e28186bf19$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $92be74e28186bf19$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("jUWNV", function(module, exports) {

var $cB76X = parcelRequire("cB76X");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e800dc90572a17f0$export$ca000e230c0caa3e(r) {
    return (0, $cB76X.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("1McSN", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $14b4446480a71deb$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("cqRtT", function(module, exports) {

$parcel$export(module.exports, "query", function () { return $90d16600d4d0aad5$export$2fa187e846a241c4; });

var $bpL62 = parcelRequire("bpL62");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $90d16600d4d0aad5$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $bpL62.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $bpL62.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("bpL62", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $84f68fe017587dc9$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $84f68fe017587dc9$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("ftUAQ", function(module, exports) {

var $bpL62 = parcelRequire("bpL62");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $b45576aed243e345$var$e;
function $b45576aed243e345$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $bpL62.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($b45576aed243e345$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("4tsVC", function(module, exports) {

var $bpL62 = parcelRequire("bpL62");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $34204f715e40dd9f$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $bpL62.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("jSRj3", function(module, exports) {

var $bpL62 = parcelRequire("bpL62");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e79c68f9006dc100$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $bpL62.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("9unhH", function(module, exports) {

var $bpL62 = parcelRequire("bpL62");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6e88fa320a9a34fc$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $bpL62.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});



parcelRegister("85Vfw", function(module, exports) {

$parcel$export(module.exports, "platform", function () { return $5e4b32e5776b136a$export$722a64dea1b767dc; });
$parcel$export(module.exports, "autoUpdate", function () { return $5e4b32e5776b136a$export$deee3a793edee05f; });
$parcel$export(module.exports, "offset", function () { return $5e4b32e5776b136a$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $5e4b32e5776b136a$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $5e4b32e5776b136a$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $5e4b32e5776b136a$export$346677f925de839c; });
$parcel$export(module.exports, "arrow", function () { return $5e4b32e5776b136a$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "computePosition", function () { return $5e4b32e5776b136a$export$48a53dcb22e581d0; });

var $diLeu = parcelRequire("diLeu");
var $hEiIP = parcelRequire("hEiIP");

var $hEiIP = parcelRequire("hEiIP");

var $4BiyL = parcelRequire("4BiyL");
function $5e4b32e5776b136a$var$getCssDimensions(element) {
    const css = (0, $4BiyL.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $4BiyL.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $hEiIP.round)(width) !== offsetWidth || (0, $hEiIP.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $5e4b32e5776b136a$var$unwrapElement(element) {
    return !(0, $4BiyL.isElement)(element) ? element.contextElement : element;
}
function $5e4b32e5776b136a$var$getScale(element) {
    const domElement = $5e4b32e5776b136a$var$unwrapElement(element);
    if (!(0, $4BiyL.isHTMLElement)(domElement)) return (0, $hEiIP.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $5e4b32e5776b136a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $hEiIP.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $hEiIP.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $5e4b32e5776b136a$var$noOffsets = /*#__PURE__*/ (0, $hEiIP.createCoords)(0);
function $5e4b32e5776b136a$var$getVisualOffsets(element) {
    const win = (0, $4BiyL.getWindow)(element);
    if (!(0, $4BiyL.isWebKit)() || !win.visualViewport) return $5e4b32e5776b136a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $5e4b32e5776b136a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $4BiyL.getWindow)(element)) return false;
    return isFixed;
}
function $5e4b32e5776b136a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $5e4b32e5776b136a$var$unwrapElement(element);
    let scale = (0, $hEiIP.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $4BiyL.isElement)(offsetParent)) scale = $5e4b32e5776b136a$var$getScale(offsetParent);
        } else scale = $5e4b32e5776b136a$var$getScale(element);
    }
    const visualOffsets = $5e4b32e5776b136a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $5e4b32e5776b136a$var$getVisualOffsets(domElement) : (0, $hEiIP.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $4BiyL.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $4BiyL.isElement)(offsetParent) ? (0, $4BiyL.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $4BiyL.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $5e4b32e5776b136a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $4BiyL.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $4BiyL.getWindow)(currentIFrame);
            currentIFrame = (0, $4BiyL.getFrameElement)(currentWin);
        }
    }
    return (0, $hEiIP.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $5e4b32e5776b136a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $4BiyL.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $4BiyL.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $hEiIP.createCoords)(1);
    const offsets = (0, $hEiIP.createCoords)(0);
    const isOffsetParentAnElement = (0, $4BiyL.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4BiyL.getNodeName)(offsetParent) !== "body" || (0, $4BiyL.isOverflowElement)(documentElement)) scroll = (0, $4BiyL.getNodeScroll)(offsetParent);
        if ((0, $4BiyL.isHTMLElement)(offsetParent)) {
            const offsetRect = $5e4b32e5776b136a$var$getBoundingClientRect(offsetParent);
            scale = $5e4b32e5776b136a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $5e4b32e5776b136a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $5e4b32e5776b136a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $4BiyL.getNodeScroll)(element).scrollLeft;
    if (!rect) return $5e4b32e5776b136a$var$getBoundingClientRect((0, $4BiyL.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $5e4b32e5776b136a$var$getDocumentRect(element) {
    const html = (0, $4BiyL.getDocumentElement)(element);
    const scroll = (0, $4BiyL.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $hEiIP.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $hEiIP.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $5e4b32e5776b136a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $4BiyL.getComputedStyle)(body).direction === "rtl") x += (0, $hEiIP.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5e4b32e5776b136a$var$getViewportRect(element, strategy) {
    const win = (0, $4BiyL.getWindow)(element);
    const html = (0, $4BiyL.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $4BiyL.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $5e4b32e5776b136a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $5e4b32e5776b136a$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $4BiyL.isHTMLElement)(element) ? $5e4b32e5776b136a$var$getScale(element) : (0, $hEiIP.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $5e4b32e5776b136a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $5e4b32e5776b136a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $5e4b32e5776b136a$var$getDocumentRect((0, $4BiyL.getDocumentElement)(element));
    else if ((0, $4BiyL.isElement)(clippingAncestor)) rect = $5e4b32e5776b136a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $5e4b32e5776b136a$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $hEiIP.rectToClientRect)(rect);
}
function $5e4b32e5776b136a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $4BiyL.getParentNode)(element);
    if (parentNode === stopNode || !(0, $4BiyL.isElement)(parentNode) || (0, $4BiyL.isLastTraversableNode)(parentNode)) return false;
    return (0, $4BiyL.getComputedStyle)(parentNode).position === "fixed" || $5e4b32e5776b136a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $5e4b32e5776b136a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $4BiyL.getOverflowAncestors)(element, [], false).filter((el)=>(0, $4BiyL.isElement)(el) && (0, $4BiyL.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $4BiyL.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $4BiyL.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $4BiyL.isElement)(currentNode) && !(0, $4BiyL.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $4BiyL.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $4BiyL.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $4BiyL.isOverflowElement)(currentNode) && !currentNodeIsContaining && $5e4b32e5776b136a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $4BiyL.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $5e4b32e5776b136a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $4BiyL.isTopLayer)(element) ? [] : $5e4b32e5776b136a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $5e4b32e5776b136a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $hEiIP.max)(rect.top, accRect.top);
        accRect.right = (0, $hEiIP.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hEiIP.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hEiIP.max)(rect.left, accRect.left);
        return accRect;
    }, $5e4b32e5776b136a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $5e4b32e5776b136a$var$getDimensions(element) {
    const { width: width, height: height } = $5e4b32e5776b136a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $5e4b32e5776b136a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $4BiyL.isHTMLElement)(offsetParent);
    const documentElement = (0, $4BiyL.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $5e4b32e5776b136a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $hEiIP.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4BiyL.getNodeName)(offsetParent) !== "body" || (0, $4BiyL.isOverflowElement)(documentElement)) scroll = (0, $4BiyL.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $5e4b32e5776b136a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $5e4b32e5776b136a$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $5e4b32e5776b136a$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $5e4b32e5776b136a$var$isStaticPositioned(element) {
    return (0, $4BiyL.getComputedStyle)(element).position === "static";
}
function $5e4b32e5776b136a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $4BiyL.isHTMLElement)(element) || (0, $4BiyL.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $4BiyL.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $5e4b32e5776b136a$var$getOffsetParent(element, polyfill) {
    const win = (0, $4BiyL.getWindow)(element);
    if ((0, $4BiyL.isTopLayer)(element)) return win;
    if (!(0, $4BiyL.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $4BiyL.getParentNode)(element);
        while(svgOffsetParent && !(0, $4BiyL.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $4BiyL.isElement)(svgOffsetParent) && !$5e4b32e5776b136a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $4BiyL.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $5e4b32e5776b136a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $4BiyL.isTableElement)(offsetParent) && $5e4b32e5776b136a$var$isStaticPositioned(offsetParent))offsetParent = $5e4b32e5776b136a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $4BiyL.isLastTraversableNode)(offsetParent) && $5e4b32e5776b136a$var$isStaticPositioned(offsetParent) && !(0, $4BiyL.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $4BiyL.getContainingBlock)(element) || win;
}
const $5e4b32e5776b136a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $5e4b32e5776b136a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $5e4b32e5776b136a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $5e4b32e5776b136a$var$isRTL(element) {
    return (0, $4BiyL.getComputedStyle)(element).direction === "rtl";
}
const $5e4b32e5776b136a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $5e4b32e5776b136a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $4BiyL.getDocumentElement,
    getClippingRect: $5e4b32e5776b136a$var$getClippingRect,
    getOffsetParent: $5e4b32e5776b136a$var$getOffsetParent,
    getElementRects: $5e4b32e5776b136a$var$getElementRects,
    getClientRects: $5e4b32e5776b136a$var$getClientRects,
    getDimensions: $5e4b32e5776b136a$var$getDimensions,
    getScale: $5e4b32e5776b136a$var$getScale,
    isElement: $4BiyL.isElement,
    isRTL: $5e4b32e5776b136a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $5e4b32e5776b136a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $4BiyL.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $hEiIP.floor)(top);
        const insetRight = (0, $hEiIP.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $hEiIP.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $hEiIP.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $hEiIP.max)(0, (0, $hEiIP.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $5e4b32e5776b136a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $5e4b32e5776b136a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $4BiyL.getOverflowAncestors)(referenceEl) : [],
        ...(0, $4BiyL.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $5e4b32e5776b136a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $5e4b32e5776b136a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $5e4b32e5776b136a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $5e4b32e5776b136a$export$37b6bde19b108ecc = (0, $diLeu.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $5e4b32e5776b136a$export$cc800923e997bb8 = (0, $diLeu.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $5e4b32e5776b136a$export$91fb6ecbd551914 = (0, $diLeu.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $5e4b32e5776b136a$export$fba63a578e423eb = (0, $diLeu.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $5e4b32e5776b136a$export$8a83211c878a3f1f = (0, $diLeu.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $5e4b32e5776b136a$export$346677f925de839c = (0, $diLeu.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $5e4b32e5776b136a$export$fe8985bb6374093c = (0, $diLeu.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $5e4b32e5776b136a$export$f2120bbfa5450bd2 = (0, $diLeu.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $5e4b32e5776b136a$export$18c8ad048e32c7d5 = (0, $diLeu.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $5e4b32e5776b136a$export$7bf07e38f3dc4b69 = (0, $diLeu.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $5e4b32e5776b136a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $5e4b32e5776b136a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $diLeu.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("diLeu", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $9af1983d804aa6fb$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $9af1983d804aa6fb$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $9af1983d804aa6fb$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $9af1983d804aa6fb$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $9af1983d804aa6fb$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $9af1983d804aa6fb$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $9af1983d804aa6fb$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $9af1983d804aa6fb$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $9af1983d804aa6fb$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $9af1983d804aa6fb$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $9af1983d804aa6fb$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("hEiIP")).rectToClientRect; });

var $hEiIP = parcelRequire("hEiIP");
function $9af1983d804aa6fb$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $hEiIP.getSideAxis)(placement);
    const alignmentAxis = (0, $hEiIP.getAlignmentAxis)(placement);
    const alignLength = (0, $hEiIP.getAxisLength)(alignmentAxis);
    const side = (0, $hEiIP.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $hEiIP.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9af1983d804aa6fb$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9af1983d804aa6fb$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9af1983d804aa6fb$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9af1983d804aa6fb$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $hEiIP.evaluate)(options, state);
    const paddingObject = (0, $hEiIP.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $hEiIP.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $hEiIP.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9af1983d804aa6fb$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $hEiIP.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $hEiIP.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $hEiIP.getAlignmentAxis)(placement);
            const length = (0, $hEiIP.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $hEiIP.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $hEiIP.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $hEiIP.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $hEiIP.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9af1983d804aa6fb$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $hEiIP.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $hEiIP.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $hEiIP.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $hEiIP.getAlignment)(placement) === alignment || (autoAlignment ? (0, $hEiIP.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9af1983d804aa6fb$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $hEiIP.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $hEiIP.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $hEiIP.placements) ? $9af1983d804aa6fb$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9af1983d804aa6fb$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $hEiIP.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $hEiIP.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $hEiIP.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $hEiIP.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9af1983d804aa6fb$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $hEiIP.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $hEiIP.getSide)(placement);
            const initialSideAxis = (0, $hEiIP.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $hEiIP.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $hEiIP.getOppositePlacement)(initialPlacement)
            ] : (0, $hEiIP.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $hEiIP.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9af1983d804aa6fb$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $hEiIP.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $hEiIP.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9af1983d804aa6fb$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9af1983d804aa6fb$var$isAnySideFullyClipped(overflow) {
    return (0, $hEiIP.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9af1983d804aa6fb$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $hEiIP.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9af1983d804aa6fb$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $9af1983d804aa6fb$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9af1983d804aa6fb$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9af1983d804aa6fb$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9af1983d804aa6fb$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9af1983d804aa6fb$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9af1983d804aa6fb$var$getBoundingRect(rects) {
    const minX = (0, $hEiIP.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $hEiIP.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $hEiIP.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $hEiIP.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9af1983d804aa6fb$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $hEiIP.rectToClientRect)($9af1983d804aa6fb$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9af1983d804aa6fb$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $hEiIP.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9af1983d804aa6fb$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $hEiIP.rectToClientRect)($9af1983d804aa6fb$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $hEiIP.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $hEiIP.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $hEiIP.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $hEiIP.getSide)(placement) === "left";
                    const maxRight = (0, $hEiIP.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $hEiIP.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9af1983d804aa6fb$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $hEiIP.getSide)(placement);
    const alignment = (0, $hEiIP.getAlignment)(placement);
    const isVertical = (0, $hEiIP.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $hEiIP.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9af1983d804aa6fb$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9af1983d804aa6fb$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9af1983d804aa6fb$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $hEiIP.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9af1983d804aa6fb$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $hEiIP.getSideAxis)((0, $hEiIP.getSide)(placement));
            const mainAxis = (0, $hEiIP.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $hEiIP.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $hEiIP.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9af1983d804aa6fb$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $hEiIP.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $hEiIP.getSideAxis)(placement);
            const mainAxis = (0, $hEiIP.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $hEiIP.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $hEiIP.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9af1983d804aa6fb$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $hEiIP.evaluate)(options, state);
            const overflow = await $9af1983d804aa6fb$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $hEiIP.getSide)(placement);
            const alignment = (0, $hEiIP.getAlignment)(placement);
            const isYAxis = (0, $hEiIP.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $hEiIP.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $hEiIP.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $hEiIP.max)(overflow.left, 0);
                const xMax = (0, $hEiIP.max)(overflow.right, 0);
                const yMin = (0, $hEiIP.max)(overflow.top, 0);
                const yMax = (0, $hEiIP.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $hEiIP.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $hEiIP.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("hEiIP", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $cd94b1e7dde1e23c$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $cd94b1e7dde1e23c$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $cd94b1e7dde1e23c$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $cd94b1e7dde1e23c$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $cd94b1e7dde1e23c$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $cd94b1e7dde1e23c$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $cd94b1e7dde1e23c$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $cd94b1e7dde1e23c$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $cd94b1e7dde1e23c$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $cd94b1e7dde1e23c$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $cd94b1e7dde1e23c$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $cd94b1e7dde1e23c$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $cd94b1e7dde1e23c$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $cd94b1e7dde1e23c$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $cd94b1e7dde1e23c$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $cd94b1e7dde1e23c$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $cd94b1e7dde1e23c$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $cd94b1e7dde1e23c$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $cd94b1e7dde1e23c$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $cd94b1e7dde1e23c$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $cd94b1e7dde1e23c$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $cd94b1e7dde1e23c$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $cd94b1e7dde1e23c$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $cd94b1e7dde1e23c$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $cd94b1e7dde1e23c$export$803cd8101b6c182b = /*#__PURE__*/ $cd94b1e7dde1e23c$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $cd94b1e7dde1e23c$export$27b07d8a310ed8b5[0], side + "-" + $cd94b1e7dde1e23c$export$27b07d8a310ed8b5[1]), []);
const $cd94b1e7dde1e23c$export$96ec731ed4dcb222 = Math.min;
const $cd94b1e7dde1e23c$export$8960430cfd85939f = Math.max;
const $cd94b1e7dde1e23c$export$2077e0241d6afd3c = Math.round;
const $cd94b1e7dde1e23c$export$a3fe094919f356fd = Math.floor;
const $cd94b1e7dde1e23c$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $cd94b1e7dde1e23c$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $cd94b1e7dde1e23c$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $cd94b1e7dde1e23c$export$7d15b64cf5a3a4c4(start, value, end) {
    return $cd94b1e7dde1e23c$export$8960430cfd85939f(start, $cd94b1e7dde1e23c$export$96ec731ed4dcb222(value, end));
}
function $cd94b1e7dde1e23c$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $cd94b1e7dde1e23c$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $cd94b1e7dde1e23c$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $cd94b1e7dde1e23c$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $cd94b1e7dde1e23c$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $cd94b1e7dde1e23c$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($cd94b1e7dde1e23c$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $cd94b1e7dde1e23c$export$2b57e0052a6d6d4c(placement) {
    return $cd94b1e7dde1e23c$export$8a000a963141ac32($cd94b1e7dde1e23c$export$f28e8f882010718a(placement));
}
function $cd94b1e7dde1e23c$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $cd94b1e7dde1e23c$export$f0989780f32bfcda(placement);
    const alignmentAxis = $cd94b1e7dde1e23c$export$2b57e0052a6d6d4c(placement);
    const length = $cd94b1e7dde1e23c$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $cd94b1e7dde1e23c$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $cd94b1e7dde1e23c$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $cd94b1e7dde1e23c$export$496432a3699e50b1(placement) {
    const oppositePlacement = $cd94b1e7dde1e23c$export$9c5e28bad23365fa(placement);
    return [
        $cd94b1e7dde1e23c$export$2b182c584985588b(placement),
        oppositePlacement,
        $cd94b1e7dde1e23c$export$2b182c584985588b(oppositePlacement)
    ];
}
function $cd94b1e7dde1e23c$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$cd94b1e7dde1e23c$var$oppositeAlignmentMap[alignment]);
}
function $cd94b1e7dde1e23c$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $cd94b1e7dde1e23c$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $cd94b1e7dde1e23c$export$f0989780f32bfcda(placement);
    let list = $cd94b1e7dde1e23c$var$getSideList($cd94b1e7dde1e23c$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($cd94b1e7dde1e23c$export$2b182c584985588b));
    }
    return list;
}
function $cd94b1e7dde1e23c$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$cd94b1e7dde1e23c$var$oppositeSideMap[side]);
}
function $cd94b1e7dde1e23c$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $cd94b1e7dde1e23c$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $cd94b1e7dde1e23c$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $cd94b1e7dde1e23c$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("4BiyL", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $359903ac817f30b9$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $359903ac817f30b9$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $359903ac817f30b9$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $359903ac817f30b9$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $359903ac817f30b9$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $359903ac817f30b9$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $359903ac817f30b9$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $359903ac817f30b9$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $359903ac817f30b9$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $359903ac817f30b9$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $359903ac817f30b9$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $359903ac817f30b9$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $359903ac817f30b9$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $359903ac817f30b9$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $359903ac817f30b9$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $359903ac817f30b9$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $359903ac817f30b9$export$7bf1f8740e3e34af; });
function $359903ac817f30b9$var$hasWindow() {
    return typeof window !== "undefined";
}
function $359903ac817f30b9$export$651544f548703224(node) {
    if ($359903ac817f30b9$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $359903ac817f30b9$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $359903ac817f30b9$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($359903ac817f30b9$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $359903ac817f30b9$export$8ee0fc9ee280b4ee(value) {
    if (!$359903ac817f30b9$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $359903ac817f30b9$export$38b2d434cce3ea22(value).Node;
}
function $359903ac817f30b9$export$45a5e7f76e0caa8d(value) {
    if (!$359903ac817f30b9$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $359903ac817f30b9$export$38b2d434cce3ea22(value).Element;
}
function $359903ac817f30b9$export$1b3bfaa9684536aa(value) {
    if (!$359903ac817f30b9$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $359903ac817f30b9$export$38b2d434cce3ea22(value).HTMLElement;
}
function $359903ac817f30b9$export$af51f0f06c0f328a(value) {
    if (!$359903ac817f30b9$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $359903ac817f30b9$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $359903ac817f30b9$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $359903ac817f30b9$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $359903ac817f30b9$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($359903ac817f30b9$export$651544f548703224(element));
}
function $359903ac817f30b9$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $359903ac817f30b9$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $359903ac817f30b9$export$78551043582a6a98();
    const css = $359903ac817f30b9$export$45a5e7f76e0caa8d(elementOrCss) ? $359903ac817f30b9$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $359903ac817f30b9$export$940d8225183e1404(element) {
    let currentNode = $359903ac817f30b9$export$4e12058fc4d51d56(element);
    while($359903ac817f30b9$export$1b3bfaa9684536aa(currentNode) && !$359903ac817f30b9$export$d1162fb0b6d4cd51(currentNode)){
        if ($359903ac817f30b9$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($359903ac817f30b9$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $359903ac817f30b9$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $359903ac817f30b9$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $359903ac817f30b9$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($359903ac817f30b9$export$651544f548703224(node));
}
function $359903ac817f30b9$export$3735103072e4a80(element) {
    return $359903ac817f30b9$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $359903ac817f30b9$export$dc8fc79fa2800137(element) {
    if ($359903ac817f30b9$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $359903ac817f30b9$export$4e12058fc4d51d56(node) {
    if ($359903ac817f30b9$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $359903ac817f30b9$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $359903ac817f30b9$export$e495491855dc5418(node);
    return $359903ac817f30b9$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $359903ac817f30b9$export$7cd01a57c8ca906c(node) {
    const parentNode = $359903ac817f30b9$export$4e12058fc4d51d56(node);
    if ($359903ac817f30b9$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($359903ac817f30b9$export$1b3bfaa9684536aa(parentNode) && $359903ac817f30b9$export$989e911fa9af580a(parentNode)) return parentNode;
    return $359903ac817f30b9$export$7cd01a57c8ca906c(parentNode);
}
function $359903ac817f30b9$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $359903ac817f30b9$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $359903ac817f30b9$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $359903ac817f30b9$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $359903ac817f30b9$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $359903ac817f30b9$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $359903ac817f30b9$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $359903ac817f30b9$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("8ScLW", function(module, exports) {
$parcel$export(module.exports, "classMap", function () { return (parcelRequire("iokeX")).classMap; });
parcelRequire("iokeX");

});
parcelRegister("iokeX", function(module, exports) {

$parcel$export(module.exports, "classMap", function () { return $d63a2b2a914410b9$export$56cc687933817664; });

var $6NpbG = parcelRequire("6NpbG");

var $fBlDI = parcelRequire("fBlDI");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d63a2b2a914410b9$export$56cc687933817664 = (0, $fBlDI.directive)(class extends (0, $fBlDI.Directive) {
    constructor(s){
        if (super(s), s.type !== (0, $fBlDI.PartType).ATTRIBUTE || "class" !== s.name || s.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(t, [s]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== t.strings && (this.nt = new Set(t.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(s);
        }
        const i = t.element.classList;
        for (const t of this.st)t in s || (i.remove(t), this.st.delete(t));
        for(const t in s){
            const r = !!s[t];
            r === this.st.has(t) || this.nt?.has(t) || (r ? (i.add(t), this.st.add(t)) : (i.remove(t), this.st.delete(t)));
        }
        return 0, $6NpbG.noChange;
    }
});

});
parcelRegister("fBlDI", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $b5bb18dcecd38f28$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $b5bb18dcecd38f28$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $b5bb18dcecd38f28$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b5bb18dcecd38f28$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $b5bb18dcecd38f28$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $b5bb18dcecd38f28$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("ljC8S", function(module, exports) {

$parcel$export(module.exports, "offsetParent", function () { return $f848f59628ca037a$export$759f2a42fd33dfde; });
/* eslint-disable @typescript-eslint/ban-types */ function $f848f59628ca037a$export$759f2a42fd33dfde(element) {
    return $f848f59628ca037a$var$offsetParentPolyfill(element);
}
function $f848f59628ca037a$export$9051df5ff5b6ece8(element) {
    return $f848f59628ca037a$var$offsetTopLeftPolyfill(element, "offsetTop");
}
function $f848f59628ca037a$export$4ad6bc00a859a01c(element) {
    return $f848f59628ca037a$var$offsetTopLeftPolyfill(element, "offsetLeft");
}
function $f848f59628ca037a$var$flatTreeParent(element) {
    if (element.assignedSlot) return element.assignedSlot;
    if (element.parentNode instanceof ShadowRoot) return element.parentNode.host;
    return element.parentNode;
}
function $f848f59628ca037a$var$ancestorTreeScopes(element) {
    const scopes = new Set();
    let currentScope = element.getRootNode();
    while(currentScope){
        scopes.add(currentScope);
        currentScope = currentScope.parentNode ? currentScope.parentNode.getRootNode() : null;
    }
    return scopes;
}
function $f848f59628ca037a$var$offsetParentPolyfill(element) {
    // Do an initial walk to check for display:none ancestors.
    for(let ancestor = element; ancestor; ancestor = $f848f59628ca037a$var$flatTreeParent(ancestor)){
        if (!(ancestor instanceof Element)) continue;
        if (getComputedStyle(ancestor).display === "none") return null;
    }
    for(let ancestor = $f848f59628ca037a$var$flatTreeParent(element); ancestor; ancestor = $f848f59628ca037a$var$flatTreeParent(ancestor)){
        if (!(ancestor instanceof Element)) continue;
        const style = getComputedStyle(ancestor);
        // Display:contents nodes aren't in the layout tree so they should be skipped.
        if (style.display === "contents") continue;
        if (style.position !== "static" || style.filter !== "none") return ancestor;
        if (ancestor.tagName === "BODY") return ancestor;
    }
    return null;
}
function $f848f59628ca037a$var$offsetTopLeftPolyfill(element, offsetTopOrLeft) {
    let value = element[offsetTopOrLeft];
    let nextOffsetParent = $f848f59628ca037a$var$offsetParentPolyfill(element);
    const scopes = $f848f59628ca037a$var$ancestorTreeScopes(element);
    while(nextOffsetParent && !scopes.has(nextOffsetParent.getRootNode())){
        value -= nextOffsetParent[offsetTopOrLeft];
        nextOffsetParent = $f848f59628ca037a$var$offsetParentPolyfill(nextOffsetParent);
    }
    return value;
}

});




})();
//# sourceMappingURL=popup.js.map
